/**
 * dailyRewardsUtils
 *
 * Ausgelagert aus DailyRewardsChart.tsx (react-refresh/only-export-components:
 * eine Komponentendatei darf nur Komponenten exportieren).
 */
import type { DailyReward } from './useMonthlyReport'

/** Baut eine lueckenlose Tagesserie fuer den gesamten Kalendermonat von
 * `period` ("YYYY-MM"), Tage ohne Reward-Eintrag werden mit 0 aufgefuellt. */
export function buildFullMonthSeries(daily: DailyReward[], period: string): DailyReward[] {
  const [yearStr, monthStr] = period.split('-')
  const year = Number(yearStr)
  const month = Number(monthStr)
  if (!year || !month) return [...daily].sort((a, b) => a.date.localeCompare(b.date))

  const byDate = new Map(daily.map((d) => [d.date, d.rewards_hnt]))
  const daysInMonth = new Date(year, month, 0).getDate()

  const series: DailyReward[] = []
  for (let day = 1; day <= daysInMonth; day += 1) {
    const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    series.push({ date: dateStr, rewards_hnt: byDate.get(dateStr) ?? 0 })
  }
  return series
}
